import type { ScheduleStopValue } from "@RequestFormV2/defaults/scheduleDefaults";
import type { PackingListRow } from "@RequestFormV2/sections/PackingList/types";

export function isPackingListStopKeyMissing(
  stopKey: string | undefined | null,
  options: { value: string }[],
): boolean {
  return Boolean(stopKey) && !options.some((option) => option.value === stopKey);
}

export function getPackingListMissingStopWarning(
  packingList: PackingListRow[] | undefined,
  stops: ScheduleStopValue[] | undefined,
): { hasWarnings: boolean } {
  if (!packingList?.length || !stops?.length) {
    return { hasWarnings: false };
  }

  const stopKeys = new Set(stops.map((stop) => stop.stop_key));

  const hasWarnings = packingList.some((item) => {
    const { pickup_stop_key: pickupStopKey, delivery_stop_key: deliveryStopKey } = item;
    if (!pickupStopKey && !deliveryStopKey) return false;
    if (pickupStopKey && !stopKeys.has(pickupStopKey)) return true;
    if (deliveryStopKey && !stopKeys.has(deliveryStopKey)) return true;
    return false;
  });

  return { hasWarnings };
}
